import React, { useState, Fragment, useContext, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import "@progress/kendo-theme-material/dist/all.css";
import { UrlServicesContext } from "../UrlServicesContext";
import axios from "axios";

const delay = 400;

export default function LoadCategoria(props) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState(null);
  const [dataAll, setDataAll] = useState(null);
  const [loading, setLoading] = useState(false);

  const { urlServices } = useContext(UrlServicesContext);

  useEffect(() => {
    const consultar = async () => {
      await axios
        .post(urlServices + "routes.php?servicio=consultarCategoria")
        .then(
          (response) => {
            setData(response.data.categoria);
            setDataAll(response.data.categoria);
            setIsLoaded(true);
          },
          (error) => {
            setIsLoaded(true);
            setError(true);
          }
        );
    };
    consultar();
  }, [urlServices]);

  const onTagsChangeCategoria = (e) => {
    props.callbackCategoria({
      text: e.target.value.text,
      id: e.target.value.id,
    });
  };

  const filterChange = (event) => {
    const timer = setTimeout(() => {
      setData(filterData(event.filter));
      setLoading(false);
    }, delay);

    setLoading(true);

    return () => clearTimeout(timer);
  };

  const filterData = (filter) => {
    const datos = dataAll.slice();
    return filterBy(datos, filter);
  };

  if (error) {
    return (
      <Fragment>
        <Grid item xs={12} sm={12}>
          <div style={{ color: "#B22222" }}>Categoría</div>
          <center>
            <br></br>
            <Alert severity="error">Error en la consulta!</Alert>
          </center>
        </Grid>
      </Fragment>
    );
  } else if (!isLoaded) {
    return (
      <Fragment>
        <Grid item xs={12} sm={12}>
          <FormLabel component="legend">Categoría</FormLabel>
          <center>
            <br></br>
            <img
              src="../../images/loading.gif"
              alt="loading"
              style={{ width: "60px" }}
            />
          </center>
        </Grid>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <FormLabel required component="legend">
          Categoría del negocio
        </FormLabel>
        <DropDownList
          data={data}
          value={props.valueCategoria}
          textField="text"
          filterable={true}
          onFilterChange={filterChange}
          onChange={onTagsChangeCategoria}
          loading={loading}
          style={{ width: "100%" }}
        />
      </Fragment>
    );
  }
}
